import gql from 'graphql-tag';
// Mutation to update KM title
export default gql`
mutation competencyDocumentUpdate(
    $documentId: UUID!,
    $workspaceId: UUID!,
  	$title:String,
  ) {
    competencyDocumentUpdate (input: {
      documentId: $documentId,
      workspaceId: $workspaceId,
      title:$title,
    }) {
        document {
            documentId
            createdAt
            lastChangedAt
            title
            workspaceId
      }
    }
  }
`;